var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.0193 0H3.86085C1.73291 0 0 1.73291 0 3.86085V25.0193C0 27.1472 1.73291 28.8801 3.86085 28.8801H25.0193C27.1472 28.8801 28.8801 27.1472 28.8801 25.0193V3.86085C28.8801 1.73291 27.1472 0 25.0193 0ZM7.44805 5.01589C8.78571 5.01589 9.88011 6.11029 9.88011 7.44795C9.88011 8.7856 8.78571 9.88 7.44805 9.88C6.1104 9.88 5.016 8.7856 5.016 7.44795C5.016 6.08 6.08011 5.01589 7.44805 5.01589ZM26.7217 25.0191C26.7217 25.9614 25.9617 26.7214 25.0193 26.7214H3.86091C2.91856 26.7214 2.15856 25.9614 2.15856 25.0191V20.1247L7.11382 14.7438C7.72176 14.075 8.78587 14.075 9.39382 14.7438L12.373 17.9967L19.517 8.96795C20.0946 8.20795 21.2499 8.20795 21.8273 8.96795L26.7217 15.1391L26.7217 25.0191Z",
    fill: "#CCCCCC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage);
export default __webpack_public_path__ + "static/media/image.5b2f04b609b813775cb862139c245f52.svg";
export { ForwardRef as ReactComponent };